<template>
  <div>
    <slot></slot>
    <component
      v-for="component in components"
      :key="component.id"
      :is="component.name"
      v-bind="component.props"
      v-on="component.listeners"
    ></component>
  </div>
</template>
<script setup>
import { provide } from 'vue'
import { BUTTONACTION } from '../../../tokens/index'
import { useTemplate } from '../../../hooks/use-template'
import { useComponent, useRouterPush } from '../hook/index'
import * as allActions from '../actions/index'
import { pgMessageBox } from '../../message-box/index'

const props = defineProps({
  actions: Object,
})

const { getTemplateData, compileData } = useTemplate()
const { components, action } = useComponent()
const { router, closeCurrentTabAndRouter } = useRouterPush()

const actionsHook = {
  component: action,
  router,
  closeCurrentTabAndRouter,
  ...allActions,
}

const getNextName = (name) => {
  const at = ['before', 'doing', 'after']
  const index = at.findIndex((a) => a === name)
  if (index !== -1 && index < 2) {
    return at[index + 1]
  } else {
    return null
  }
}
const run = async (params, next) => {
  if (!params.action?.code) {
    return null
  } else if (actionsHook[params.action?.code]) {
    return actionsHook[params.action?.code](params, props.actions, next)
  } else {
    return Promise.reject(`未定义【${params.action?.code}】方法`)
  }
}
const execute = (menu, compileSource, name, resData) => {
  if (!name) return resData
  const compile = getTemplateData(null, { ...props.actions, ...resData, ...compileSource })
  const params = compileData(menu[name], compile) ?? {}
  params.id = `${menu.id}${name}`
  return run(params, (res) =>
    execute(menu, compileSource, getNextName(name), { ...resData, [`${name}Res`]: res })
  ).then((res) =>
    execute(menu, compileSource, getNextName(name), { ...resData, [`${name}Res`]: res })
  )
}

const runActions = async (menu, compileSource) => {
  return execute(menu, compileSource, 'before', {}).catch((error) => {
    if (error) {
      pgMessageBox({ message: error.msg ?? error })
    }
    return Promise.resolve()
  })
}
provide(BUTTONACTION, runActions)
defineExpose({
  runActions,
})
</script>
